import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { validateToken } from '../../Store/Actions/LoginActions';
const queryString = require('query-string');
class SSOLoginSuccess extends Component {

	constructor(props) {
		super(props);
		this.state = {
			success: false,
			error: false,
			errMsg: ""
		};
	}

	componentDidMount() {

		// Take out params from querystring and add to redux.
		// Will need to validate token before redirecting to schedule.
		let queryParsed = queryString.parse(this.props.location.search);

		let token = queryParsed.Token;
		//verify token against backend;
		// dispatch(verifyToken(token));
		// Set SSO state as successful in REDUX on return value from that rest action;
		this.props.tokenValidate(token);

	}
	render() {
		if (this.props.isAuthorized) {
			// set localstorage if SSO was used with URL
			localStorage.setItem('ssologin', "true");
			return this.props.redirectPath ?
				<Redirect to={{
					pathname: this.props.redirectPath,
					state: { from: this.props.location }
				}} /> :
				<Redirect to={{
					pathname: '/schedule',
					state: { from: this.props.location }
				}} />;
		}


		return (
			<h2>Logging In</h2>
		);
	}

}

const mapStateToProps = (state) => ({
	isAuthorized: state.auth.isAuthenticated,
	redirectPath: state.auth.redirectPath
});

const mapDispatchtoProps = dispatch => ({
	tokenValidate: (token) => dispatch(validateToken(token))
});

export default connect(mapStateToProps, mapDispatchtoProps)(SSOLoginSuccess);


// WEBPACK FOOTER //
// ./src/Pages/Login/SSOLoginSuccess.js